exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.redactor-air, .redactor-toolbar {\n    z-index: 0 !important;\n}\n", ""]);

// exports
